import { CSSProperties } from 'react';

export const cardStyles = ({ isShowing = false }): CSSProperties => {
  return {
    position: 'absolute',
    bottom: '12.5%',
    left: '10px',
    backgroundColor: 'rgba(23,35,34,0.75)',
    padding: '12px 15px',
    color: '#ffffff',
    width: '320px',
    maxWidth: '70%',
    display: isShowing ? 'block' : 'none',
    borderRadius: '5px',
  };
};

export const cardTextStyles1: CSSProperties = {
  fontSize: '14px',
  fontWeight: 300,
  marginBottom: '5px',
  color: 'rgba(255, 255, 255, 0.75)',
};

export const cardTextStyles2: CSSProperties = {
  fontSize: '20px',
};

// eslint-disable-next-line import-x/no-anonymous-default-export
export default {
  cardStyles,
};
